import { Stepper } from "@tameeni/ui";
import { useSteps } from "../hooks/use-steps";

export default function StepperBar() {
  const { steps, currentStepIndex } = useSteps();

  return (
    <Stepper
      currentStepIndex={currentStepIndex}
      steps={steps}
    />
  );
}
